
import Vue from "vue";
import { Day } from "./@types";
export default Vue.extend({
  props: {
    value: Array as () => string[],
    readonly: Boolean,
  },
  data() {
    return {
      allDays: [Day.Mon, Day.Tue, Day.Wed, Day.Thu, Day.Fri, Day.Sat, Day.Sun],
      showError: false,
    };
  },
  inject: {
    form: { default: null },
  },
  computed: {
    shouldValidate(): boolean {
      return true;
    },
    hasError(): boolean {
      return !this.value.length;
    },
  },
  methods: {
    validate(force?: boolean, value?: any): boolean {
      if (force) {
        this.showError = this.hasError;
      }
      return this.hasError;
    },
    reset() {
      this.$emit("input", []);
      this.resetValidation();
    },
    resetValidation() {
      this.showError = false;
    },
    onFocus() {
      //this.lastKeyCode = 0;
    },
    toggle(d: string) {
      if (this.readonly) {
        return;
      }
      this.resetValidation();
      this.$emit("input", this.value.includes(d) ? this.value.filter(v => v != d) : this.value.concat([d]));
      this.$nextTick(() => this.validate(true));
    },
  },
  created() {
    const frm = (this as any).form;
    frm && frm.register(this);
  },
  beforeDestroy() {
    const frm = (this as any).form;
    frm && frm.unregister(this);
  },
});
